<template>
	<div>
		<InputCode
			:error="!!error.length"
			@input="sendCode($event)"
		/>
		<div class="error" v-if="error">
			{{ error }}
		</div>
		<div class="message" :class="$store.state.darkTheme && 'message--theme-black'" v-else>
			<template v-if="time">
				Получить новый код можно через 00:{{ time }}
			</template>
			<Button
				v-else
				text="Отправить код повторно"
				secondary
				@click="repeatSendCode()"
			/>
		</div>
		<Button
				text="Подтвердить номер телефона"
				@click="sendCode()"
		/>
<!--    <Button text="Назад/Изменить номер телефона" secondary back @click="backPhone()"/>-->
	</div>
</template>

<script>
import InputCode from '@/components/InputCode'
import Button from '@/components/ButtonComponent'
import axios from 'axios'

export default {
	name: 'CodeSlide',
	components: {
		InputCode, Button
	},
	props: {
		typePage: {type: String, required: true}
	},
	data() {
		return {
			error: '',
			time: 0,
			timer: null
		}
	},
	mounted() {
		this.startTimerCode()
	},
	methods: {
		startTimerCode() {
			this.time = 59
			this.timer = setInterval(() => {
				this.time--
				if (this.time === 0) {
					this.time = null
					clearInterval(this.timer)
				}
			}, 1000);
		},
		repeatSendCode() {
			this.$store.dispatch('setLoader', true)
			axios({
				method: "post",
				url: this.$store.state.api.url + '/phone',
				data: {
					phone: this.$store.state.user.phone,
					user_id: this.$store.state.user.id
				}
			})
			.then(response => {
				console.log(response);
				if (response.data.status) {
					this.$store.dispatch('setLoader', false)
					this.startTimerCode()
				} else {
					this.$store.dispatch('setLoader', false)
					this.$store.dispatch('setNotifiction', { state: 'error', text: 'К сожалению, произошла ошибка. Попробуйте позже'})
				}
			})
			.catch(error => {
				console.log(error);
				this.$store.dispatch('setLoader', false)
				this.$store.dispatch('setNotifiction', { state: 'error', text: 'К сожалению, произошла ошибка. Попробуйте позже'})
			})
        },
		sendCode(code) {
			this.$store.dispatch('setLoader', true)
			axios({
				method: "post",
				url: this.$store.state.api.url + '/code',
				data: {
					code: code,
					user_id: this.$store.state.user.id
				}
			})
			.then(response => {
				console.log(response);
				if (response.data.status) {
					this.$emit('successSlide')
					this.$store.dispatch('setLoader', false)
				} else {
					if (response.data.message === 'not_user') {
						this.$emit('registration')
						this.$store.dispatch('setLoader', false)
						if (this.typePage === 'login') {
							this.$store.dispatch('setNotifiction',
                  { state: 'warning',
                            text: 'Кажется, вы не зарегистрированы на сайте. Пожалуйста, пройдите регистрацию по ссылке: https://www.moiglaza.ru/hcp/'
                  })
						}
					} else {
						this.$store.dispatch('setLoader', false)
						this.error = 'К сожалению, вы ввели неправильный код. Попробуйте ввести его еще раз'
					}
				}
			})
			.catch(error => {
				console.log(error);
				this.$store.dispatch('setLoader', false)
				this.$store.dispatch('setNotifiction', { state: 'error', text: 'К сожалению, произошла ошибка. Попробуйте позже'})
			})
		},
    backPhone() {
      this.$emit('prevSlide')
    }
	}
}
</script>

<style lang="scss" scoped>
	.message {
		margin-top: 20px;
		margin-bottom: 30px;
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #767676;
		text-align: center;
		&--theme-black {
			color: white;
		}
	}
	.error {
		margin-top: 20px;
		font-weight: 400;
		font-size: 18px;
		line-height: 18px;
		color: #EB6161;
	}
</style>
